<div class="frame-container">
  <mat-icon (click)="dialogRef.close()" class="close-icon">close</mat-icon>
  <iframe class="tv-frame" [src]="data | safeUrl" allowfullscreen> </iframe>
</div>
